import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type ThemeType = 'light' | 'dark';

@Component({
  selector: 'u-theme-wrapper',
  templateUrl: './u-theme-wrapper.component.html',
  styleUrls: ['./u-theme-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UThemeWrapperComponent {
  theme = input<ThemeType>('light');
}
